import Vue from 'vue'
import Vuex from 'vuex'
import Tickers from '@/store/tickers'
import OptimizationConfig from '@/store/optimization-config'
import Auth from "@/store/auth";

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Tickers,
    OptimizationConfig,
    Auth,
  },

  state() {
    return {
      toastr: []
    }
  },

  mutations: {
    addToastr: ({ toastr }, item) => toastr.push(item),
    removeToastr: ({ toastr }, item) => toastr.splice(toastr.indexOf(item), 1)
  },

  actions: {
    toastr({ commit }, { message, type = "error", timeout = 5000 }) {
      const item = { message, type };
      commit("addToastr", item);
      setTimeout(() => commit("removeToastr", item), timeout);
    }
  }

  
})
